import React from 'react';

export const StyleContext = React.createContext({});
